<template>
    <div>
      <Pos_recall_bill/>
    </div>
  </template>
  
  <script>
  import Pos_recall_bill from "@/components/adminArin/pos_system/pos/Pos_bill_recall";
  export default {
    name: "PosRecall",
    components: {
      Pos_recall_bill
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  